import { ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
import './TotalExpense.scss';

const TotalExpense = ({
  title,
  value,
  lastMonthValue,
  negative = false,
  image,
}) => {
  // Format currency with comma and 2 decimal places
  const formatCurrency = (num) =>
    num?.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    
  // Calculate percentage change
  const percentageChange = lastMonthValue
    ? (((value - lastMonthValue) / lastMonthValue) * 100).toFixed(2)
    : 0;

  // Determine change direction
  const isPositiveChange = negative
    ? parseFloat(percentageChange) < 0
    : parseFloat(percentageChange) > 0;

  const ChangeIcon = isPositiveChange ? ArrowUpIcon : ArrowDownIcon;

  lastMonthValue = lastMonthValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <div className='commission-card-expenses'>
      <div className='commission-card-expenses__title-expenses'>
        <p>{title}</p>
      </div>

      <div className='commission-card-expenses__content-expenses'>
        <div className='commission-card-expenses__value'>
          <p>${formatCurrency(value)}</p>

          <div className='commission-card-expenses__last-month-expenses'>
            <p>Last month</p> <p>{lastMonthValue}</p>
          </div>
        </div>

        <div
          className={`commission-card-expenses__changes ${
            isPositiveChange
              ? 'commission-card-expenses__changes--positive'
              : 'commission-card-expenses__changes--negative'
          }`}
          style={{ display: lastMonthValue === '$0.00' ? 'none' : '' }}
        >
          <ChangeIcon size={16} className='commission-card__change-icon' />
          <span>{Math.abs(percentageChange)}%</span>
        </div>
      </div>
    </div>
  );
};

export default TotalExpense;
